<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
@if (link) {

    <div class="info-window-flex-row">
        <span class="label-large">Link radio:</span>
        <div class="control">
            <sui-select-component [config]="radiosSelect"
                                  [readonly]="readonlyMode"></sui-select-component>
        </div>
    </div>

    @if (radiosSelect.getValue().extendedByT280DnLink) {
        <div class="info-window-flex-row">
            <span class="label-full-width">Location {{ radiosSelect.getValue().compliantLocation }}
                will be extended with MH-T280 device.</span>
        </div>
    }

    @if (antennaFromSelect.options.length > 1) {
        <div class="info-window-flex-row">
            <span class="label-large">{{ link.getFromStation().getName() }} antenna:</span>
            <div class="control">
                <sui-select-component [config]="antennaFromSelect" [readonly]="readonlyMode"></sui-select-component>
            </div>
        </div>
    }
    @if (antennaToSelect.options.length > 1) {
        <div class="info-window-flex-row">
            <span class="label-large">{{ link.getToStation().getName() }} antenna:</span>
            <div class="control">
                <sui-select-component [config]="antennaToSelect" [readonly]="readonlyMode"></sui-select-component>
            </div>
        </div>
    }

    <div class="info-window-flex-row">
        <span class="label-large">Link frequency:</span>
        <div class="control">
            <sui-select-component [config]="frequencySelect"
                                  [readonly]="readonlyMode"></sui-select-component>
        </div>
    </div>

    <div class="info-window-flex-row">
        <span class="label-large">Mark link as:</span>
        <div class="control">
            <sui-select-enum-component [config]="linkState"
                                       [readonly]="readonlyMode"></sui-select-enum-component>
        </div>
    </div>

    @if (radiosSelect.getValue().isSupportsPolarity()) {
        <div class="info-window-flex-row">
            <span class="label-large">Polarity:</span>
            <span class="label-large">
                {{ link.getSectorPolarity() | translateEnum: 'SectorPolarityEnum' }}
            </span>
        </div>
    }
}
